import { render, staticRenderFns } from "./MarkdownRenderer.vue?vue&type=template&id=64174c12&scoped=true"
import script from "./MarkdownRenderer.vue?vue&type=script&lang=js"
export * from "./MarkdownRenderer.vue?vue&type=script&lang=js"
import style0 from "./MarkdownRenderer.vue?vue&type=style&index=0&id=64174c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64174c12",
  null
  
)

export default component.exports